import React from 'react';
import {
  AppBar,
  Button,
  Typography,
  Toolbar,
  Fab,
  Drawer,
  List,
  ListItem,
  Divider,
  withStyles,
  withWidth
} from '@material-ui/core';
import {isWidthUp, isWidthDown} from '@material-ui/core/withWidth';
import classNames from 'classnames';
import {CryptxMenu} from './CryptxMenu';
import {Menu} from "@material-ui/icons";

const styles = theme => ({
  grow: {
    flexGrow: 1,
  },
  removeShadow: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing.unit
  },
  login: {
    borderRadius: 17,
    borderWidth: 2,
    marginRight: theme.spacing.unit,
  },
  register: {
    borderRadius: 17,
  },
  menuIcon: {
    paddingRight: theme.spacing.unit / 2
  },
  menu: {
    paddingLeft: theme.spacing.unit * 12
  },
  drawerMenuList: {
    backgroundColor: theme.palette.primary.lighter,
    padding: theme.spacing.unit * 4
  },
  paper: {
    backgroundColor: theme.palette.primary.lighter,
  },
  logo: {
    maxWidth: 200,
    [theme.breakpoints.down('md')]: {
      maxWidth: 100
    }
  },
  menuItem: {
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textDecoration: 'none',
    padding: theme.spacing.unit,
    fontSize: theme.spacing.unit * 1.6,
    textTransform: 'uppercase',
    '&:hover': {
      color: theme.palette.primary.light
    },
    '&:focus': {
      color: '#FFF'
    }
  }
});

const menuItems = [
  {name: 'Home', link: '#'},
  {name: 'Trading View', link: '#'},
  {name: 'Pricing', link: '#'},
  {name: 'Contact Us', link: '#'},
  {name: 'Invest', link: '#'},
  {name: 'Blog', link: '#'},
];

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false
    };
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
  }

  handleDrawerToggle() {
    this.setState(prevState => ({isDrawerOpen: !prevState.isDrawerOpen}))
  }

  render() {
    const {classes, width} = this.props;
    return (
      <div>
        {isWidthDown('sm', width) &&
        (<Drawer open={this.state.isDrawerOpen} onClose={this.handleDrawerToggle} classes={{paper: classes.paper}}
          >
            <List className={classes.drawerMenuList}>
              {menuItems.map((menuItem, index) => (
                <ListItem key={index.toString()}>
                  <a href={menuItem.link} className={classes.menuItem} onClick={this.handleDrawerToggle}>
                    {menuItem.name}
                  </a>
                  <Divider/>
                </ListItem>
              ))}
            </List>
          </Drawer>
        )}
        <AppBar position="static" className={classes.removeShadow}>
          <Toolbar>
            {isWidthDown('sm', width) && (<Menu className={classes.menuIcon} onClick={this.handleDrawerToggle}/>)}
            <img src="images/logo-white.png" alt="Logo" className={classes.logo}/>
            <div className={classNames(classes.grow, classes.menu)}>
              {isWidthUp('sm', width, false) && <CryptxMenu menuItems={menuItems}/>}
            </div>
            <Button variant="outlined" size="small" color="inherit" className={classes.login}>Login</Button>
            <Button variant="contained" size="small" color="secondary" className={classes.register}>
              Register
            </Button>
          </Toolbar>
        </AppBar>
      </div>
    )
  }
}

export default withWidth()(withStyles(styles)(Header));
